import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import "./About.scss"
import lotus from './assets/lotus-yellow.png'
import logo1 from './assets/Logo 1.png'
import logo2 from './assets/Logo 2.png'
import logo3 from './assets/Logo 3.png'
import logo4 from './assets/Logo 4.png'
import logo5 from './assets/Logo 5.png'



function About() {
    const history = useHistory();
    const goToRoute = useCallback((path) =>  { console.log(path); history.push(path); }, [history]);


  return (
    <div className="main-container">
        <div className="about-main-area">
            <div>
                <div className="title">Om oss</div>
            </div>
            <div className="about-text-area">
              <div>
              Ivris är en checklista som forskare på Mälardalens högskolan (Akademin för ekonomi, samhälle och teknik, NOMP Nya organisations - och managementpraktiker forskargrupp) har utvecklat i samarbete med FoUiS (Forskning och Utveckling i Sörmland), Eskilstuna kommun (Vård- och Omsorgsförvaltningen) och Hjälpmedelscentralen i Eskilstuna, som var partners i det Vinnova-finansierat forskningsprojektet “IVRIS – Att introducera välfärdsteknik genom realisering av innovationsförmåga i samverkan” (2018-02955, som utfördes 2018-2021). Representanter för de äldre har också inkluderats som projektdeltagare tillsammans med vårdpersonal. Projektet syftade till att utveckla sätt att samarbeta inom och mellan organisationer för att kunna förbättra hur ny teknik introduceras i välfärdstjänster. Ivris är tänkt vara ett verktyg för detta syfte.
              </div>
              <div style={{padding: '10px 0px'}}>
              Mer information om projektet:
              </div>
              <div>
              https://www.mdh.se/en/malardalen-university/research/research-projects/ivris---introducing-welfare-technology-through-the-realization-of-collaborative-innovation-capacity
              </div>
              <div style={{padding: '25px 0px'}}>
              Har du frågor om eller synpunkter på Ivris Checklista, kontakta gärna karl.schultz@fou.sormland.se
              </div>
              <div>
              UI/UX Designer: Andreea Strineholm
              </div>


          </div>
          <div className="top-right-nav" style={{height: '250px'}}>
            <img style={{margin: "0px auto"}} height="98px" width="151px" src={lotus}></img>
            <button className="nav-btn" onClick={() => goToRoute('/checklista')}>STARTA CHECKLISTAN</button>
            <button className="nav-btn" onClick={() => goToRoute('/introduktion')}>INTRODUKTION</button>
            <button className="nav-btn" onClick={() => goToRoute('/hurfunkardet')}>HUR FUNKAR DET</button>

          </div>

          <div className="logos">
            <img height="69px" width="128px" src={logo1}></img>
            <img height="89px" width="98px" src={logo2}></img>
            <img style={{position: 'relative', right: '12%'}} height="107px" width="234px" src={logo4}></img>

            <div style={{padding: '10px 0px 0px 30px'}}>
              <img style={{paddingRight: '10px'}} height="54px" width="127px" src={logo3}></img>

              <img height="36px" width="168px" src={logo5}></img>
            </div>
          </div>

        </div>
    </div>
  );
}

export default About;
